(function($, undefined) {
	'use strict';

	var init = function() {};

	$(window).ready(function() {
		init();
	});
})(jQuery);
